export { default } from './WelcomeToHashrateSection'